/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockCountTranGrid extends Serenity.EntityGrid<IcStockCountTranRow,any> {
        protected getColumnsKey() { return IcStockCountTranColumns.columnsKey; }
        protected getDialogType() { return IcStockCountTranDialog; }
        protected getEditorType() { return IcStockCountTranEditor; }
        protected getIdProperty() { return IcStockCountTranRow.idProperty; }
        protected getInsertPermission() { return IcStockCountTranRow.insertPermission; }
        protected getLocalTextPrefix() { return IcStockCountTranRow.localTextPrefix; }
        protected getService() { return IcStockCountTranService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            // Q.first(filters, x => x.field == fld.DocDate).init = w => {

            //     (w as Serenity.DateEditor).valueAsDate = new Date(Date.now());

            //     let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
            //     endDate.valueAsDate = new Date(Date.now());
            // };

            // var q = Q.parseQueryString();
            // if (q["SysDocNo"]) {
            //     var category = Q.tryFirst(filters, x => x.field == "SysDocNo");
            //     category.init = e => {
            //         e.element.getWidget(Serenity.LookupEditor).value = q["SysDocNo"];
            //     };
            // }


            return filters;
        }
        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected beforeLoadEntity() {
            let self = this;
            

        }
        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }
        protected getButtons() {
            var buttons = super.getButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'add-button'), 1)
            buttons.filter(x => x.cssClass = "refresh-button")


            // Max page width = 277
            let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
                0: { field: "Id", title: "ID", cellWidth: 5, halign: 'left' },
                1: { field: "SysDocNo", title: "เลขที่เอกสาร", cellWidth: 30, halign: 'left' },
                2: { field: "LineItemNo", title: "ลำดับ", cellWidth: 30, halign: 'left' },
                3: { field: "SkuCode", title: "รหัสSKU", cellWidth: 30, halign: 'left' },
                4: { field: "PluCode", title: "รหัสPLU", cellWidth: 30, halign: 'left' },
                5: { field: "ItemRemark", title: "บันทึก", cellWidth: 30, halign: 'left' },
                6: { field: "QtyCount", title: "จำนวน", cellWidth: 30, halign: 'left' },
                
                7: { field: "PurUnit", title: "หน่วย", cellWidth: 30, halign: 'left' },
                8: { field: "PurUnitRatio", title: "อัตราส่วนPLU/(SKU)", cellWidth: 30, halign: 'left' },
                9: { field: "QtyOnhand", title: "รวมเป็นเงินรวม", cellWidth: 20, halign: 'left' },

            }
            return buttons;
        }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();
            
                //--set new set of grid columns---
                //--get content width
                //slick-viewport slick-viewport-top slick-viewport-left
                let ele = document.getElementsByClassName("slick-viewport");
                var bordermg = 60;
                var eleWidth = ele.item(0).clientWidth - bordermg * 5;
                var totalcolw = 0;
                //---100,260,600,120,100,220,220 = 1620 = base (wide screen)
                //---1469 - notebook, --1135 when have menu 
                let propItems = this.getPropertyItems();
                let items = this.getColumns();
                items.forEach((item, idx) => {
                    let pItem = Q.tryFirst(propItems, x => x.name == item.sourceItem.name);
                    totalcolw += pItem.width;
    
                });
                items.forEach((item, idx) => {
                    let pItem = Q.tryFirst(propItems, x => x.name == item.sourceItem.name);
                    pItem.resizable = true;
                    pItem.width = (eleWidth / totalcolw) * pItem.width;
    
    
                });
                let c = this.postProcessColumns(this.propertyItemsToSlickColumns(propItems));
                this.slickGrid.setColumns(c);
                this.slickGrid.resizeCanvas();
    
              

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('QtyCount'),                    
                    new Slick.Aggregators.Sum('QtyOnhand')

                ]

            });
            return grid;
        }
        
    }
}